import { z as e } from "zod";
// src/common/index.ts
var t = e.string().uuid(), n = t, r = e.string().min(1).max(512).regex(/^[A-Za-z0-9_-]+$/, "Cursor must be an opaque base64url value"), i = e.coerce.number().int().min(1).max(100).default(50), a = e.enum(/* @__PURE__ */ "AUTHORITY_INVALID.NOT_READY.PRIORITY_FIELD_REQUIRED.INTEGRATION_RETIRED.INTEGRATION_NOT_RETIRED.PAYLOAD_TOO_LARGE.INTERNAL_ERROR.INVALID_REQUEST.SESSION_REQUIRED.CAPABILITY_DENIED.EMPLOYEE_REQUIRED.NOT_FOUND.VERSION_CONFLICT.TEAM_NAME_EXISTS.CUSTOMER_NAME_EXISTS.INELIGIBLE_PARTICIPANT.SCHEDULE_NAME_EXISTS.ROUTINE_NAME_EXISTS.SECTION_OVERLAP.CONFIRMATION_REQUIRED.OVERRIDE_OVERLAP.SCHEDULE_ARCHIVED.CUSTOMER_ARCHIVED.CUSTOMER_ASSIGNMENTS_BLOCK_ARCHIVE.CUSTOMER_DELETE_BLOCKED.ASSIGNMENT_EXISTS.TEAM_INACTIVE.KNOWN_NUMBER_EXISTS.INVALID_PHONE_NUMBER.PHONE_NUMBER_EXISTS.CLIENT_CODE_EXISTS.CLIENT_CODE_EXHAUSTED.INVALID_AUDIO.WRITE_UNCERTAIN.CUSTOMER_AUDIT_POLICY_UNAVAILABLE.CUSTOMER_ACTIVITY_UNAVAILABLE.DEPENDENCY_BLOCKED.LAST_ACTIVE_ADMIN.ROLE_DEPENDENCY.IDEMPOTENCY_CONFLICT.VERIFICATION_UNAVAILABLE.UNSUPPORTED_VERIFICATION_DESTINATION.CONTACT_EXISTS.CONTACT_NOT_VERIFIED.RATE_LIMITED.IDENTITY_UNAVAILABLE.DIRECTORY_UNAVAILABLE.STORAGE_UNAVAILABLE.DEPENDENCY_UNAVAILABLE.FEATURE_UNAVAILABLE".split(".")), o = e.object({
	explanationCode: e.string().min(1).max(80),
	dependencies: e.array(e.object({
		kind: e.string().min(1).max(80),
		id: t,
		explanationCode: e.string().min(1).max(80).optional(),
		teamId: t.optional(),
		teamName: e.string().min(1).max(100).optional(),
		customerId: t.optional(),
		scheduleId: t.optional(),
		routineId: t.optional(),
		positionId: t.optional()
	}).strict()).max(100),
	assignments: e.array(e.object({
		assignmentId: t,
		teamId: t,
		teamName: e.string().min(1).max(100)
	}).strict()).max(100).optional(),
	nextCursor: r.nullable().optional(),
	archivalAvailableAfterAssignmentsRemoved: e.boolean().optional()
}).strict(), s = e.object({
	code: a,
	message: e.string().min(1).max(300),
	correlationId: n,
	fieldErrors: e.record(e.string(), e.string().max(300)).optional(),
	details: o.optional()
}).strict();
function c(t) {
	return e.object({
		items: e.array(t),
		nextCursor: r.nullable()
	}).strict();
}
export { a as canonicalErrorCodeSchema, s as canonicalErrorSchema, n as correlationIdSchema, c as createPageSchema, o as managementErrorDetailsSchema, r as opaqueCursorSchema, i as pageLimitSchema, t as uuidSchema };

//# sourceMappingURL=index.js.map